// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__DsefG","sidebar__wrapper":"Sidebar_sidebar__wrapper__lialt","sidebar__support":"Sidebar_sidebar__support__gu7Yg"};